import { buildURI, useLazyFetch } from '@hn-front/utils';
import { useCallback } from 'react';
import { COMMON_API } from '../constants/routes';
import { getToken } from '../../../../registration/utils';
var usePostSeenCardsSessions = function () {
    var _a = useLazyFetch(), makeFetch = _a[0], state = _a[1];
    var postSeenCardsSessions = useCallback(function (studentId, sessionIds) {
        if (sessionIds.length === 0)
            return;
        var csrfToken = getToken();
        makeFetch(buildURI(COMMON_API.postSeenCardsSessions, {
            pathParams: { studentId: studentId },
        }), {
            method: 'POST',
            body: JSON.stringify({
                session_ids: sessionIds,
                authenticity_token: csrfToken,
            }),
        });
    }, [makeFetch]);
    return [postSeenCardsSessions, state];
};
export { usePostSeenCardsSessions };
